export default __webpack_public_path__ + "static/media/promos-2.8d3c65fa.webp";